import { Modal, Button, Form } from "react-bootstrap";
import { useState } from "react";

export default function TransactionModal({
    show,
    onClose,
    onSubmit
}) {
    const [excelFile, setExcelFile] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async () => {
        if (!excelFile) return;

        setIsSubmitting(true);

        const formData = new FormData();
        formData.append("file", excelFile);

        await onSubmit(formData);

        setIsSubmitting(false);
        setExcelFile(null);
        onClose();
    };

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Upload Bank Transactions</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Label>Excel File</Form.Label>
                        <Form.Control
                            type="file"
                            accept=".xlsx,.xls"
                            onChange={(e) => setExcelFile(e.target.files[0])}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    disabled={!excelFile || isSubmitting}
                    onClick={handleSubmit}
                >
                    {isSubmitting ? "Uploading..." : "Submit"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
